import axios from 'axios';
import { config } from '../config';
import { authHeader } from '../helpers';

const axiosInstance = axios.create({
  baseURL: '' // keep if you rely on relative URLs
});

// 🔥 GLOBAL RESPONSE HANDLER
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const status = error?.response?.status;

    if (status === 401) {
      localStorage.removeItem('user');

      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }

      // ✅ STOP propagation completely
      return new Promise(() => {});
    }

    return Promise.reject(error);
  }
);

export const reportService = {
  exportCsv,
  exportProgressCsv,
  getInceptionDate,
  queueProgressJob, // still usable for other routes
  queueDateRangeJob // new one for /date-range
};

function exportCsv(data) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' }
  };

  return axiosInstance
    .post(`${config.reports}/date-range`, data, requestOptions)
    .then((response) => {
      return response;
    });
}

function queueProgressJob(data) {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json', ...authHeader() }
  };

  return axiosInstance.post(`${config.reports}/progress`, data, requestOptions);
}

function queueDateRangeJob(data) {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json', ...authHeader() }
  };

  return axiosInstance.post(`${config.reports}/date-range`, data, requestOptions);
}

function exportProgressCsv(data) {
  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
    params: data
  };

  return axiosInstance.get(`${config.reports}/progress`, requestOptions).then((response) => {
    return response;
  });
}

function getInceptionDate(type) {
  return axiosInstance.get(`${config.reports}/inception-date/${type}`).then((response) => {
    return response;
  });
}
